import React, { useState, useCallback } from "react";
import { Modal, Button, Slider } from "antd";
import Cropper from "react-easy-crop";
import { Locale } from "../../utils";
import { getCroppedImg } from "./cropUtils";

const i18n = Locale.getInstance();

const ImageCropModal = ({ 
  open, 
  imageSrc, 
  aspectRatio, 
  onCancel, 
  onComplete 
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleOk = async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    
    setLoading(true);
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      onComplete(croppedImage);
      setLoading(false);
    } catch (error) {
      console.error("Error cropping image:", error);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    onCancel();
  };

  // Parse aspect ratio string (e.g., "16:9" or "9:16")
  const getAspectRatio = () => {
    if (!aspectRatio) return undefined;
    const [width, height] = aspectRatio.split(":").map(Number);
    return width / height;
  };

  return (
    <Modal
      open={open}
      title={i18n.t("productEdit.cropImage") || "裁剪图片"}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={i18n.t("base.modal.okText")}
      cancelText={i18n.t("base.modal.cancelText")}
      confirmLoading={loading}
      width={600}
      centered
    >
      <div style={{ position: "relative", width: "100%", height: 400, background: "#000" }}>
        {imageSrc && (
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={getAspectRatio()}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
            style={{
              containerStyle: {
                width: "100%",
                height: "100%",
                position: "relative",
              },
            }}
          />
        )}
      </div>
      <div style={{ marginTop: 16 }}>
        <label style={{ display: "block", marginBottom: 8 }}>
          {i18n.t("productEdit.zoom") || "缩放"}:
        </label>
        <Slider
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={setZoom}
        />
      </div>
    </Modal>
  );
};

export default ImageCropModal;
